export const INTERACTION_EVENT_NAME = 'dashboards_panel_plugin_picker_clicked';
export const INTERACTION_ITEM = {
  TOGGLE_DROPDOWN: 'toggle_panel_plugin_picker',
  SELECT_PANEL_PLUGIN: 'select_panel_plugin',
  CHANGE_TAB: 'change_tab', // for ref - PanelVizTypePicker
  SEARCH: 'search', // for ref - PanelVizTypePicker
  BACK_BUTTON: 'back_button', // for ref - PanelVizTypePicker
};
